import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { timeout, map } from 'rxjs/operators';

const mainUrl = environment.url;

@Injectable({
  providedIn: 'root'
})
export class WeightService {

  constructor(private http: HttpClient) { }

  getAllWeights(): Observable<any> {
    return this.http.get(mainUrl + 'param-weigths')
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  createWeight(form): Observable<any> {
    return this.http.post(mainUrl + 'param-weigth', form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getWeightById(id): Observable<any> {
    return this.http.get(mainUrl + 'param-weigth/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  updateWeight(id, form): Observable<any> {
    return this.http.put(mainUrl + 'param-weigth/' + id, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteWeight(id): Observable<any> {
    return this.http.delete(mainUrl + 'param-weigth/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': window.localStorage.getItem('token')
     });

    return headers;
  }
}